import React, {Component} from 'react';
import {HeadingSmall, ParagraphLarge, ParagraphXSmall} from 'baseui/typography';

class PrivacyPolicy extends Component {
    render = () => {
        return <div>
            <HeadingSmall style={{margin: 0}}>PRIVACY POLICY</HeadingSmall>
            <ParagraphXSmall style={{margin: 0}}>Last modified: Jul 21, 2021</ParagraphXSmall>
            <ParagraphLarge>EncLock LLC does not collect user's personal information of any kind on its website or application.</ParagraphLarge>
        </div>
    };
}

export default PrivacyPolicy;
